/**
 * Accessorial Status enum
 *
 * Value prop serves as a sequence indicator.
 */

export const AccessorialStatus = {
  /** Not finalized yet - excluded from AR or AP calculations */
  PENDING: {
    value: 0,
    name: 'Pending',
    code: 'pending',
    desc: 'Accessorial that is not finalized yet and should be excluded from AR or AP calcs.',
  },
  /** Charged or manually approved - included in AR and AP calculations */
  APPROVED: {
    value: 100,
    name: 'Approved',
    code: 'approved',
    desc: 'Accessorial that has been charged or manually approved and should be included in AR and AP calcs.',
  },
  /** Credit card authorization declined - excluded from AR/AP */
  DECLINED: {
    value: 200,
    name: 'Declined',
    code: 'declined',
    desc: 'Accessorial with credit card authorization which has been declined at least once and is no longer valid to charge the credit card. It also should not be included in any AR or AP calcs because it was declined too many times and never actually charged.',
  },
  /** Credit card authorization expired - excluded from AR/AP */
  EXPIRED: {
    value: 300,
    name: 'Expired',
    code: 'expired',
    desc: 'Accessorial with credit card authorization which is no longer valid to charge the credit card. It also should not be included in any AR or AP calcs because it expired before it was used.',
  },
} as const

export type AccessorialStatusCode = typeof AccessorialStatus[keyof typeof AccessorialStatus]['code']
